import styled from 'styled-components'

export const DropDownWrap = styled.div`
  position: relative;
  z-index: 100;
  height: 36px;
  user-select: none;
`
export const DropDown = styled.div`
  border: 0.5px solid rgba(97, 105, 113, 0.2);
  border-radius: 12px;
  overflow: hidden;
  background: ${({ theme }) => theme.bodyBackground};
`
export const DropDownValue = styled.div`
  background: rgba(97, 105, 113, 0.08);
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  justify-content: center;
  color: #dcb97e;
  padding: 8px 15px;
  cursor: pointer;
  min-width: 82px;
`
export const DropDownListWrap = styled.div`
  background: rgba(97, 105, 113, 0.08);
  display: grid;
  grid-gap: 8px;
  padding: 4px 10px;
`

export const DropDownItem = styled.div<{ active?: boolean }>`
  cursor: pointer;
  color: ${({ active }) => (active ? '#dcb97e' : 'inherit')};
  text-align: center;

  :hover {
    color: #dcb97e;
  }
`
